import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_down\"><path d=\"M280.064 382.464a38.4 38.4 0 0 1 54.272 0L512 560.128l177.664-177.664a38.4 38.4 0 1 1 54.272 54.272l-204.8 204.8a38.4 38.4 0 0 1-54.272 0l-204.8-204.8a38.4 38.4 0 0 1 0-54.272z\" p-id=\"4551\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol